import { ClassifaiSetting } from "../ClassifaiSetting";
import { CatalogItem } from "./CatalogItem";

export class TransferCatalogItem {

  constructor(
    public itemsToTransfer?: CatalogItem[],
    public targetItem?: CatalogItem,
    public isClassifAi?: boolean,
    public classifaiSetting?: ClassifaiSetting,
    public mergeStrategy?: 'use-source' | 'keep-target'
  ) {

  }
}
